import { StyleClass } from "../Styles/CSS";

export const QuickSelectorStyleClasses = {
    outer: StyleClass(`selectorBoxLayout`, {
        display: `inline`,
    }),
    Inactive: (backgroundColor: string) =>
        StyleClass(`quickSelectorInactive_${backgroundColor}`, {
            padding: "2px 10px !important",
            fontSize: "18px",
            color: "silver",
            background: backgroundColor,
        }),
    Selected: (backgroundColor: string) =>
        StyleClass(`quickSelectorSelected_${backgroundColor}`, {
            borderRadius: `5px`,
            background: backgroundColor,
            color: `black`,
            fontWeight: `bold`,
            fontSize: `23px`,
            position: `relative`,
            top: `3px`,
            padding: "4px 9px 2px 9px !important",
        }),
};
